import { render } from "./CalendarEventSkeleton.vue?vue&type=template&id=128b3659&scoped=true"
import script from "./CalendarEventSkeleton.vue?vue&type=script&lang=js"
export * from "./CalendarEventSkeleton.vue?vue&type=script&lang=js"

import "./CalendarEventSkeleton.vue?vue&type=style&index=0&id=128b3659&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128b3659"]])

export default __exports__